(function ($){
    let filterUpdated = false;

    // filter checkboxes
    $('.js-filter-input').on('change', function() {
        let that = $(this),
            keyName = that.attr('name'),
            selectedValues = [];

        // update filter status
        filterUpdated = true;

        $('.js-filter-input[name="' + keyName +'"]:checked').each(function() {
            let value = $(this).val();
            selectedValues.push(value);
        });

        let urlArgs = selectedValues.join(',');
        let encodedUrlArgs = encodeURIComponent(urlArgs);
        let newUrl = window.location.pathname + window.location.search;

        if (selectedValues.length > 0 && urlArgs !== 'all') {
            newUrl = updateQueryStringParameter(newUrl, keyName, encodedUrlArgs);
        } else {
            newUrl = removeQueryStringParameter(newUrl, keyName);
        }

        if (filterUpdated) {
            history.pushState(null, '', newUrl);
        }
    });

    // cancel specific filter
    $('.js-cancel-filter').on('click', function (e){
        e.preventDefault();

        let that = $(this),
            attr = that.data('attr'),
            arg = that.data('arg');

        removeArgumentsFromURL(attr, [arg]);
    });

    // reload page after hiding a dropdown
    $('.filter__control .dropdown').on('hidden.bs.dropdown', event => {
        if(filterUpdated === true){
            location.reload();
        }
    });

    // remove all filters
    $('.js-clean-filter').on('click', function (e){
        e.preventDefault();
        removeAllParamsFromURL();
    });
})(jQuery);

/**
 * Remove specified arguments from the URL and update the current URL.
 * @param {string} attribute - The name of the attribute to remove.
 * @param {Array<string>} args - The array of arguments to remove.
 */
function removeArgumentsFromURL(attribute, args) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (!params.has(attribute)) {
        return;
    }

    const attributeValues = params.get(attribute);
    const attributeValuesArray = attributeValues.split(',');

    const filteredAttributeValues = attributeValuesArray.filter((value) => {
        return args.findIndex((arg) => arg.toString() === value) === -1;
    });

    if (filteredAttributeValues.length === 0) {
        params.delete(attribute);
    } else {
        params.set(attribute, filteredAttributeValues.join(','));
    }

    let newURL = url.origin + url.pathname;

    if (params.toString() !== '') {
        newURL += '?' + params.toString();
    }

    newURL += url.hash;

    history.replaceState(null, null, newURL);
    location.reload();
}


/**
 * Remove all query string parameters from the current URL and reload the page.
 */
function removeAllParamsFromURL() {
    const url = window.location.href;
    const urlParts = url.split('?');

    if (urlParts.length > 1) {
        const baseUrl = urlParts[0];
        window.history.replaceState({}, '', baseUrl);
        location.reload();
    }
}

/**
 * Update or add a query string parameter in the provided URL and return the modified URL.
 * @param {string} url - The original URL.
 * @param {string} key - The name of the parameter to update or add.
 * @param {string} value - The new value for the parameter.
 * @returns {string} The modified URL with the updated or added parameter.
 */
function updateQueryStringParameter(url, key, value) {
    let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    let separator = url.indexOf('?') !== -1 ? '&' : '?';

    if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
    } else {
        return url + separator + key + '=' + value;
    }
}

/**
 * Remove a query string parameter from the provided URL and return the modified URL.
 * @param {string} url - The original URL.
 * @param {string} key - The name of the parameter to remove.
 * @returns {string} The modified URL with the specified parameter removed.
 */
function removeQueryStringParameter(url, key) {
    let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');

    if (url.match(re)) {
        return url.replace(re, '$1').replace(/[?&]$/, '');
    } else {
        return url;
    }
}

